module.exports = __webpack_public_path__ + "static/home-ourproduct-md365bc-b2bc4b004f8e543392e68fcc984269f6.png";